import React from "react";
import { Stack, Skeleton, Box } from "@mui/material";

export default function SideBarSkeleton() {
  return (
    <Stack
      direction={{ xs: "row", lg: "column" }}
      sx={{
        width: { xs: "100%", lg: "100%" },
        height: { xs: "300px", lg: "100%" },
        padding: ".5rem",
        position: { xs: "absolute", lg: "static" },
        top: "120px",
        zIndex: 100,
        gap: { xs: "1rem", lg: "2rem" },
        overflowX: "auto",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {/* Switch Button Skeleton */}
      <Skeleton
        variant="rectangular"
        sx={{
          width: { xs: "150px", lg: "100%" },
          height: "48px",
          borderRadius: ".7rem",
        }}
      />

      {/* Categories Section */}
      <Stack sx={{  gap: ".4rem" }}>
        {/* Category Title */}
        <Skeleton
          variant="rectangular"
          sx={{
            width: { xs: "150px", lg: "100%" },
            height: "48px",
            borderRadius: ".7rem",
          }}
        />

        {/* Category Items */}
        {Array.from({ length: 5 })?.map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            sx={{
              width: { xs: "150px", lg: "100%" },
              height: "42px",
              borderRadius: ".6rem",
            }}
          />
        ))}
      </Stack>

      {/* Mobile Filters Skeleton */}
      <Box sx={{ display: { xs: "block", lg: "none" } }}>
        <Skeleton
          variant="rectangular"
          sx={{
            width: "150px",
            height: "48px",
            borderRadius: ".7rem",
          }}
        />
      </Box>
    </Stack>
  );
}
